import { api } from './client'

export type DashboardData = {
  stats: {
    stories: { total: number; todo: number; in_progress: number; in_review: number; done: number }
    in_sprint: { total: number; todo: number; doing: number; done: number }
    blocked: number
    this_week: number
    velocity: number | null
    points: { total: number; done: number }
  }
  active_sprint: ActiveSprint | null
  my_work: StorySummary[]
  activity: ActivityItem[]
  today_events?: TodayEvents
}

export type TodayEvents = {
  events: Array<{
    id: number
    type: 'meeting' | 'focus' | 'due' | 'milestone'
    title: string
    start_at: string
    end_at: string | null
    color: string | null
  }>
  stories: Array<{
    id: number
    key: string
    title: string
    scheduled_start: string
    scheduled_end: string | null
    epic_color: string | null
    status_category: string
  }>
}

export type ActiveSprint = {
  id: number
  name: string
  goal: string | null
  start_date: string | null
  end_date: string | null
  capacity_points: number | null
  story_count: number
  total_points: number
  done_points: number
  percent_done: number
}

export type StorySummary = {
  id: number
  key: string
  title: string
  priority: 'low' | 'med' | 'high'
  due_date: string | null
  estimate_points: number | null
  status_name: string
  status_category: string
  status_color: string | null
  epic_name: string | null
  epic_color: string | null
}

export type ActivityItem = {
  kind: string
  when: string
  actor: string | null
  story: {
    id: number
    key: string
    title: string
    status_category: string
    status_name: string
    epic_name: string | null
  }
}

export async function getDashboard(projectId: number): Promise<DashboardData> {
  return api<DashboardData>('/dashboard', { query: { project_id: projectId } })
}
